import {ToggleButtonGroup} from '@wandb/components';
import React from 'react';

interface MultiButtonProps {
  ariaLabel?: string;
  keys: string[];
  labels?: string[];
  selected?: string;
  onChange?: (selected: string) => void;
  disabled?: boolean;
}
const MultiButton: React.FC<MultiButtonProps> = props => {
  return (
    <ToggleButtonGroup
      aria-label={props.ariaLabel ?? 'Select an option'}
      isDisabled={props.disabled}
      items={props.keys.map((key, i) => ({
        children: props.labels?.[i] ?? props.keys[i],
        id: key,
      }))}
      onSelectionChange={keys => {
        const selectedKey = keys.values().next().value;
        if (typeof selectedKey === 'string') {
          props.onChange?.(selectedKey);
        }
      }}
      selectedKeys={props.selected != null ? [props.selected] : []}
      selectionMode="single"
      disallowEmptySelection
      size="md"
    />
  );
};

export default MultiButton;
